const MAX_EXEMPTIONS_COUNT = 25;

export default {
  attributesType: {
    string: 'String',
    number: 'Number',
    boolean: 'Boolean',
    object: 'JSON Editor',
  },
  reservedGroupAttributes: ['sudo', 'ldapGroups', 'posixGroups', 'radius', 'sambaEnabled'],
  rulesType: {
    company: 'Company',
    costCenter: 'Cost Center',
    department: 'Department',
    description: 'Description',
    employeeType: 'Employee Type',
    jobTitle: 'Job Title',
    location: 'Location',
  },
  dynamiceErrorUpdateMode: {
    update: 'update',
    remove: 'remove',
  },
  membershipSuggestions: {
    maxExemptions: MAX_EXEMPTIONS_COUNT,
    maxExemptionsError: `Cannot add more than ${MAX_EXEMPTIONS_COUNT} users.`,
    exemptionFieldLabel: 'The following users are exempt from this rule',
  },
};
